import { defineStore } from "pinia";

interface SettingsStoreState {
    autoSend: boolean;
    showShare: boolean;
}

export const useSettingsStore = defineStore("SettingsStore", {
    state: (): SettingsStoreState => ({
        autoSend: false,
        showShare: false,
    }),

    actions: {
        openShare(): void {
            this.showShare = true;
            document.body.style.overflow = "hidden";
        },
        closeShare(): void {
            document.body.style.overflow = "auto";
            this.showShare = false;
        },
    },
});
